const style = document.createElement('style');
document.getElementsByTagName('head')[0].appendChild(style);
//style.type = 'text/css';
const css = styles => {
  if (style.styleSheet) {
    style.styleSheet.cssText += styles;
  } else {
    style.appendChild(document.createTextNode(styles));
  }
};

export const applyStyles = ({ from, to, properties }) => {
  const e = document.createElement(from);
  document.body.appendChild(e);
  const p = getComputedStyle(e);
  const p2 = properties.map(property => `${property}: ${p[property]};`);

  css(`
${to} {
${p2.join('\n')}
}`);
};
